// src/icons/ChevronLeft.tsx
import { jsx } from "@emotion/react/jsx-runtime";
var ChevronLeft = ({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15 20L7 12L15 4",
        stroke: "currentColor",
        strokeWidth,
        strokeLinecap,
        strokeLinejoin
      }
    )
  }
);

export {
  ChevronLeft
};
